import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { AutomationStepIcon } from '../../svgs/icons/AutomationStepIcon';
import { styleSheet } from './styles';

interface IProps {
	publishedStepReferences?: Api.IAutomationStepReference[];
	draftStepReferences?: Api.IAutomationStepReference[];
	status?: Api.TemplateStatus;
	maxStepsToDisplay?: number;
	className?: string;
	styles?: StyleDeclarationValue[];
}

export const AutomationSteps: React.FC<IProps> = props => {
	const { className, styles, publishedStepReferences, draftStepReferences, status, maxStepsToDisplay } = props;
	let steps: Api.IAutomationStepReference[] = [];

	steps =
		status === Api.TemplateStatus.Draft
			? draftStepReferences || []
			: publishedStepReferences || draftStepReferences || [];

	const visibleSteps = steps?.slice(0, maxStepsToDisplay);

	const overflowSteps = steps.length > maxStepsToDisplay ? steps.slice(maxStepsToDisplay) : [];
	return visibleSteps?.length > 0 ? (
		<div className={`${css(styleSheet.container, ...(styles || []))} automation-steps ${className || ''}`}>
			{visibleSteps.map(x => {
				return (
					<AutomationStepIcon
						className={css(styleSheet.stepIcon)}
						key={x.id}
						type={x._type as Api.AutomationStepModelType}
					/>
				);
			})}
			{overflowSteps?.length > 0 && (
				<span className={css(styleSheet.stepsOverflowLabel)}>{`... ${overflowSteps.length} more`}</span>
			)}
		</div>
	) : null;
};
